module.exports = __webpack_public_path__ + "media/product/t-7-3db9bbab.png";